<div #footer class="quick-bet__footer" [ngClass]="{ 'quick-bet__footer-iOS': quickBetUtils.isiOS() }">
    @if ((!quickBetState().hasClosedPick && !quickBetState().hasLockedPick) || isEpcot) {
        <div
            class="quick-bet__footer-save-to-betslip-button-container"
            [ngClass]="{ 'half-sheet-add-button-text': !isEpcot && quickBetConfig.isAddToBetslipCtaTextEnabled, 'epcot': isEpcot }">
            <button
                wrapText="{{ !isEpcot }}"
                ds-button
                kind="secondary"
                variant="outline"
                size="large"
                class="quick-bet-button-add-to-betslip"
                [disabled]="quickBetState().isDisabled"
                (click)="addToBetslipClick()">
                {{ isEpcot ? sitecore.quickBetButtonStates.AddToBetslip : sitecore.quickBetButtonStates.GoToBetslip }}
            </button>
        </div>
    }
    <div class="quick-bet__footer-action-button-container">
        <bs-quick-bet-action-button [rewardTokenContext]="rewardTokenContext" />
    </div>
</div>
